import { ApiService } from '../../../ApiService';

export class FileService {
  public static readFile(file: Blob): Promise<string> {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    return new Promise((res, rej) => {
      reader.onload = () => res(reader.result as string);
      reader.onerror = (error) => rej(error);
    });
  }

  public static virusScan(file: Blob): Promise<void> {
    return FileService.readFile(file).then((x: string) =>
      ApiService.post<void>('/api/v1/security/files/virus_scan', { file: x }),
    );
  }
}
